module.exports = __webpack_public_path__ + "img/icon_heart_22.c68d7c7f.svg";